import "./CaseEdit.css";
import React, { useEffect, useContext, useState } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import Layout from "../../components/common/Layout";
import axios from "axios";
import AlertContext from "../../context/alert/alertContext";
import Alerts from "../layout/Alerts";
import checkTime from "../../components/constants/CheckTime"

const CaseEdit = props => {
  
  const pagePermission =
      JSON.parse(localStorage.getItem("permission")) === null
      ? {IsCreate: false,
        IsDelete: false,
        IsUpdate: false,
        IsView: false}
      : JSON.parse(localStorage.getItem("permission")).filter(c => parseInt(c.MenuId) === 3)[0];
  const alertContext = useContext(AlertContext);
  const { setAlert } = alertContext;
  const [showFamily, setShowFamily] = useState(false);
  const userId =
    JSON.parse(localStorage.getItem("user")) === null
      ? null
      : JSON.parse(localStorage.getItem("user"))[0].Id;
  const [caseOfficeDdl, setCaseOfficeDdl] = useState([]);
  const [caseTypeDdl, setCaseTypeDdl] = useState([]);
  const [countryDdl, setCountryDdl] = useState([]);
  const [basisDdl, setBasisDdl] = useState([]);
  const [typeOfMarkDdl, setTypeOfMarkDdl] = useState([]);
  const [profitCentreDdl, setProfitCentreDdl] = useState([]);
  const [taxTreatmentDdl, setTexTreatmentDdl] = useState([]);
  const [caseStatusDdl, setCaseStatusDdl] = useState([]);
  const [billingCurrencyDdl, setBillingCurrencyDdl] = useState([]);
  const [familyData, setFamilyData] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showDuplicate, setShowDuplicate] = useState(false);

  const [caseFormData, setCaseFormData] = useState({
    caseReference: "",
    copyNamesDetailFrom: "",
    family: "",
    title: "",
    profitCentreId: 0,
    profitCentreName: "Please Select",
    typeOfMarkId: 0,
    typeOfMarkName: "Please Select",
    caseOfficeId: 0,
    caseOfficeName: "Please Select",
    caseTypeId: 0,
    caseTypeName: "Please Select",
    countryId: 0,
    countryName: "Please Select",
    basisId: 0,
    basisName: "Please Select",
    noInSeries: "",
    keepOnTop: "",
    purchaseOrderNo: "",
    taxTreatmentId: 0,
    taxTreatmentName: "Please Select",
    billingCurrencyId: 0,
    billingCurrencyCode: "Please Select",
    caseStatusId: 1,
    caseStatusName: "Not yet filed",
    createBy: userId
  });
  const [dataShow, setDataShow] = useState({
    applicationNo: '',
    registrationNo: '',
    fileReference: ''
  });
  const [searchFormData, setSearchFormData] = useState({
    title : '',
    family: '',
    caseType : { value: 0, label: "Select All" },
    basis : { value: 0, label: "Select All" },
    typeOfMark : { value: 0, label: "Select All" },
  });

  const handleCaseTypeChange = (e) => {
    setCaseFormData({
      ...caseFormData,
      caseTypeId: e.value,
      caseTypeName: e.label
    }); 

    /* Load new status */
    //reloadCaseStatus(e.value, e.label);

  };

  const chooseFamily = v => {
    setShowFamily(false);
    setCaseFormData({
      ...caseFormData,
      family: v.family,
      caseTypeId: v.caseTypeId,
      caseTypeName: v.caseTypeName,
      basisId: v.basisId,
      basisName: v.basisName || "Please Select",
      typeOfMarkId: v.typeOfMarkId,
      typeOfMarkName: v.typeOfMarkName || "Please Select",
      copyNamesDetailFrom: ""
    });
  };
  const familyColumn = [
    {
      cell: row => (
        <div>
          <button
            className="btn btn-sm btn-success"
            onClick={() => {
              chooseFamily(row);
            }}
          >
            <i className="fa fa-plus"></i>
          </button>
        </div>
      ),
      ignoreRowClick: false,
      allowOverflow: true,
      button: true
    },
    {
      name: "Family",
      selector: "family",
      sortable: true,
      wrap: true
    },
    // {
    //   name: "Title",
    //   selector: "title",
    //   sortable: true,
    //   wrap: true
    // },
    {
      cell: row => (
        <img 
          height = "auto" 
          width="100px" 
          style={{ padding: "0px 5px" }}
          alt="IMG"
          src = {
            row.FilePath === null ?
            "/images/logo/no-img.png"
            : "/images/uploads/" + row.FilePath
          } />
      ),
      name: "Image",
      sortable: true,
      wrap: true
    },
    {
      name: "Case Type",
      selector: "caseTypeName",
      sortable: true,
      wrap: true
    },
    {
      name: "Basis",
      selector: "basisName",
      sortable: true,
      wrap: true
    },
    {
      name: "Type Of Mark",
      selector: "typeOfMarkName",
      sortable: true,
      wrap: true
    }
  ];
  const value_update = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_URL + "/api/cases/" + props.match.params.id
      )
      .then(res => {
        setCaseFormData({
          caseReference: res.data[0].CaseReference,
          copyNamesDetailFrom: "",
          family: res.data[0].Family,
          title: res.data[0].Title,
          profitCentreId: res.data[0].ProfitCentreId,
          profitCentreName: res.data[0].ProfitCentreName,
          typeOfMarkId: res.data[0].TypeOfMarkId,
          typeOfMarkName: res.data[0].TypeOfMarkName,
          caseOfficeId: res.data[0].CaseOfficeId,
          caseOfficeName: res.data[0].CaseOfficeName,
          caseTypeId: res.data[0].CaseTypeId,
          caseTypeName: res.data[0].CaseTypeName,
          countryId: res.data[0].CountryId,
          countryName: res.data[0].CountryName,
          basisId: res.data[0].BasisId,
          basisName: res.data[0].BasisName,
          noInSeries: res.data[0].NoInSeries,
          keepOnTop: res.data[0].KeepOnTopNote,
          purchaseOrderNo: res.data[0].PurchaseOrderNo,
          taxTreatmentId: res.data[0].TaxTreatmentId,
          taxTreatmentName: res.data[0].TaxTreatmentName,
          billingCurrencyId: res.data[0].BillingCurrencyId,
          billingCurrencyCode: res.data[0].BillingCurrencyCode,
          caseStatusId: res.data[0].CaseStatusId,
          caseStatusName: res.data[0].CaseStatusName,
          createBy: userId
        });
        setDataShow({
          applicationNo: res.data[0].ApplicationNo,
          registrationNo: res.data[0].RegistrationNo,
          fileReference: res.data[0].FileReference
        });

        /* Load new status */
        //reloadCaseStatus(res.data[0].CaseTypeId, res.data[0].CaseTypeName);
        //console.log('caseTypeName : ' + res.data[0].CaseTypeName);

      });
  };
  const saveAdd = () => {
    if (props.match.path.indexOf("add") > 0) {
      axios
        .post(process.env.REACT_APP_API_URL + "/api/cases", caseFormData)
        .then(res => {
          if (res.data.status === "0") {
            setAlert(res.data.msg, "success");
            props.history.push("/cases/view/" + res.data.id);
          }else {
            setAlert(res.data.msg, "danger");
            setShowConfirm(false);
          }
        })
        .catch(err => {
          setAlert(err, "danger");
        });
    } else if (props.match.path.indexOf("edit") > 0) {
      axios
        .put(
          process.env.REACT_APP_API_URL + "/api/cases/" + props.match.params.id,
          caseFormData
        )
        .then(res => {
          if (res.data.status === "0") {
            setAlert(res.data.msg, "success");
            props.history.push("/cases/view/" + props.match.params.id);
          } else {
            setAlert(res.data.msg, "danger");
            setShowConfirm(false);
          }
        });
    }
  };
  const checkdup = () => {
    if (props.match.path.indexOf("add") > 0){
      axios
        .get(process.env.REACT_APP_API_URL + "/api/case/manage/checkcaseduplicate", {
          params: {
            family: caseFormData.family, 
            caseOffice : caseFormData.caseOfficeId, 
            caseType : caseFormData.caseTypeId, 
            country : caseFormData.countryId
          }
        })
        .then(res => {
          if (res.data[0].ISDUPLICATE > 0) {
            setShowDuplicate(true);
            setShowConfirm(false);
          }else {
            saveAdd();
          }
        });
    }else{
      saveAdd();
    }
  }

  const reloadfamily = () => {
    axios
      .get(process.env.REACT_APP_API_URL + "/api/family/getfamily")
      .then(res => {
        setFamilyData(res.data);
      });
  }

  useEffect(() => {
    checkTime();
    document.addEventListener("mousedown",  (e) => { checkTime() });
    if(!pagePermission.IsUpdate){
      window.location.href = "/home";
    }
    document.getElementsByName("title")[0].focus();
    axios.get(process.env.REACT_APP_API_URL + "/api/casetype/ddl").then(res => {
      setCaseTypeDdl([...caseTypeDdl, ...res.data]);
    });
    axios
      .get(process.env.REACT_APP_API_URL + "/api/caseoffice/ddl")
      .then(res => {
        setCaseOfficeDdl([...caseOfficeDdl, ...res.data]);
      });
    axios.get(process.env.REACT_APP_API_URL + "/api/country/ddl").then(res => {
      setCountryDdl([...countryDdl, ...res.data]);
    });
    axios.get(process.env.REACT_APP_API_URL + "/api/basis/ddl").then(res => {
      setBasisDdl([...basisDdl, ...res.data]);
    });
    axios
      .get(process.env.REACT_APP_API_URL + "/api/typeofmark/ddl")
      .then(res => {
        setTypeOfMarkDdl([...typeOfMarkDdl, ...res.data]);
      });
    axios
      .get(process.env.REACT_APP_API_URL + "/api/profitcentre/ddl")
      .then(res => {
        setProfitCentreDdl([...profitCentreDdl, ...res.data]);
      });
    axios
      .get(process.env.REACT_APP_API_URL + "/api/taxtreatment/ddl")
      .then(res => {
        setTexTreatmentDdl([...taxTreatmentDdl, ...res.data]);
      });

    axios
      .get(process.env.REACT_APP_API_URL + "/api/casestatus/ddl")
      .then(res => {
        setCaseStatusDdl([...caseStatusDdl, ...res.data]);
      });
      
    axios
      .get(process.env.REACT_APP_API_URL + "/api/billingcurrency/ddl")
      .then(res => {
        setBillingCurrencyDdl([...billingCurrencyDdl, ...res.data]);
      });
    if (props.match.path.indexOf("edit") > 0) {
      value_update();
    }
    //eslint-disable-next-line
  }, []);

  const reloadCaseStatus = async (id, val) => {
    //console.log('start reload : ' + id + " : " + val);
    var g ='';
    if(val == 'Enquiry' || val == 'General' || val == 'Non-IP')
    { g = 2; }
    else
    { g = 1; }
    //console.log('g : ' + g);

    /* Prepared */
    await axios
    .get(process.env.REACT_APP_API_URL + "/api/casestatus/ddl")
    .then(res => {
      setCaseStatusDdl(
        res.data.filter(function(data) {
          //console.log(data);
          return data.grp == g || data.grp === null;

        })
      );

      //setCaseStatusDdl([...caseStatusDdl, ...res.data]);
    });
    //console.log('end reload');
  };

  const onChange = e =>
    setCaseFormData({ ...caseFormData, [e.target.name]: e.target.value });
  const button = () => {
    return (
      <div className="text-right mb-2 mt-2">
        <div>
          <button
            className="btn btn-success ml-2"
            type="button"
            onClick={() => {
              if (
                caseFormData.title === "" ||
                caseFormData.caseOfficeId === 0 ||
                caseFormData.caseTypeId === 0 ||
                caseFormData.countryId === 0
              ) {
                if(caseFormData.title === "") { setAlert("title is null! Plese fill", "warning") };
                if(caseFormData.caseOfficeId === 0) { setAlert("Case Office is null! Plese select", "warning") };
                if(caseFormData.caseTypeId === 0) { setAlert("Case Type is null! Plese select", "warning") };
                if(caseFormData.countryId === 0) { setAlert("Country is null! Plese select", "warning") };
              } else {
                setShowConfirm(true);
              }
            }}
          >
            <i className="fa fa-save"></i> Save
          </button>
          {props.match.path.indexOf("edit") > 0 && (
            <button
              className="btn btn-secondary ml-2"
              type="button"
              onClick={() => value_update()}
            >
              <i className="fa fa-refresh"></i> Reset
            </button>
          )}
          <Link to="/cases">
            <button className="btn btn-danger ml-2" type="button">
              <i className="fa fa-reply"></i> Cancel
            </button>
          </Link>
        </div>
      </div>
    );
  };
 
  return (
    <Layout activeLinkTo="/cases" menuId="3">
      <div className="container-fluid" style={{ minHeight: 500 }}>
        <Alerts />
        {button()}
        <div className="card border-secondary">
          {props.match.path.indexOf("add") > 0 && (
            <h5 className="card-header text-white bg-primary">Add Case</h5>
          )}
          {props.match.path.indexOf("edit") > 0 && (
            <h5 className="card-header text-white bg-primary">Edit Case</h5>
          )}

          <div className="card-body">
            {/*show when edit only [start]*/}
            {props.match.path.indexOf("edit") > 0 && (
              <div className="card">
                <div className="card-body">
                  <div className="form-group row">
                    <div className="col-md-2">
                      <label className="control-label sbold l-view">
                        Case Reference :
                      </label>
                    </div>
                    <div className="col-md-4">
                      <input
                        readOnly
                        type="text"
                        className="form-control signature form-control-sm"
                        value={caseFormData.caseReference}
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="control-label l-view">
                        Application No.:
                      </label>
                    </div>
                    <div className="col-md-4">
                      <input
                        readOnly
                        type="text"
                        className="form-control signature form-control-sm"
                        value={dataShow.applicationNo}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-6">
                      <input
                        readOnly
                        type="text"
                        className="form-control signature form-control-sm"
                        value={caseFormData.caseTypeName}
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="control-label l-view">
                        Registration No.:
                      </label>
                    </div>
                    <div className="col-md-4">
                      <input
                        readOnly
                        type="text"
                        className="form-control signature form-control-sm"
                        value={dataShow.registrationNo}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-6">
                      <input
                        readOnly
                        type="text"
                        className="form-control signature form-control-sm"
                        value={caseFormData.caseStatusName}
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="control-label l-view">
                        File Reference:
                      </label>
                    </div>
                    <div className="col-md-4">
                      <input
                        readOnly
                        type="text"
                        className="form-control signature form-control-sm"
                        value={dataShow.fileReference}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/*show when edit only [end]*/}

            <div className="card mt-2">
              <div className="card-body row">
                <div className="form-group col-lg-6 labelPadRight">
                  { (props.match.path.indexOf("add") > 0 && caseFormData.family === '' ) && (<div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      Copy Detail :
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control  form-control-sm"
                        name="copyNamesDetailFrom"
                        value={caseFormData.copyNamesDetailFrom}
                        onChange={onChange}
                      />
                    </div>
                  </div>)}
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      Family :
                    </label>
                    <div className="input-group col-md-9">
                      <input
                        readOnly
                        type="text"
                        name="family"
                        placeholder="family code"
                        className="form-control  form-control-sm"
                        value={caseFormData.family}
                      />
                      {caseFormData.family !== "" && (
                        <button
                          type="button"
                          style={{
                            cursor: "pointer",
                            padding: "1px 6px 0px 0px",
                            position: "absolute",
                            right: "49px",
                            height: "100%",
                            color: "royalblue"
                          }}
                          onClick={() => {
                            setCaseFormData({
                              ...caseFormData,
                              family: "",});
                            
                          }}
                        >
                          <i
                            className="fa fa-times-circle"
                            aria-hidden="true"
                          ></i>
                        </button>
                      )}

                      <div className="input-group-append">
                        <button disabled={props.match.path.indexOf("edit") > 0}
                          className="btn btn-sm btn-outline-primary form-control-sm"
                          type="button"
                          onClick={() => {
                            reloadfamily();
                            setShowFamily(true);
                          }}
                        >
                          <i className="fa fa-search"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      Matter<span style={{ color: "red" }}> * </span>:
                    </label>
                    <div className="input-group col-md-9">
                      <textarea
                        className="form-control form-control-sm"
                        rows="2"
                        name="title"
                        value={caseFormData.title}
                        onChange={onChange}
                      ></textarea>
                    </div>
                  </div>
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      Profit Centre :
                    </label>
                    <div className="col-md-9">
                      <Select
                        name="profitCentre"
                        value={{
                          value: caseFormData.profitCentreId || 0,
                          label:
                            caseFormData.profitCentreName || "Please Select"
                        }}
                        options={profitCentreDdl}
                        onChange={e => {
                          setCaseFormData({
                            ...caseFormData,
                            profitCentreId: e.value,
                            profitCentreName: e.label
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      Type of Mark :
                    </label>
                    <div className="col-md-9">
                      <Select
                        name="typeOfMark"
                        value={{
                          value: caseFormData.typeOfMarkId || 0,
                          label: caseFormData.typeOfMarkName || "Please Select"
                        }}
                        options={typeOfMarkDdl}
                        onChange={e => {
                          setCaseFormData({
                            ...caseFormData,
                            typeOfMarkId: e.value,
                            typeOfMarkName: e.label
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group col-lg-6">
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      Case Office<span style={{ color: "red" }}> * </span>:
                    </label>
                    <div className="col-md-9">
                      <Select isDisabled={props.match.path.indexOf("edit") > 0}
                        name="caseOffice"
                        value={{
                          value: caseFormData.caseOfficeId || 0,
                          label: caseFormData.caseOfficeName || "Please Select"
                        }}
                        options={caseOfficeDdl}
                        onChange={e => {
                          setCaseFormData({
                            ...caseFormData,
                            caseOfficeId: e.value,
                            caseOfficeName: e.label
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      Case Type<span style={{ color: "red" }}> * </span>:
                    </label>
                    <div className="col-md-9">
                      <Select isDisabled={caseFormData.family !== '' || props.match.path.indexOf("edit") > 0}
                        name="caseType"
                        value={{
                          value: caseFormData.caseTypeId || 0,
                          label: caseFormData.caseTypeName || "Please Select"
                        }}
                        options={caseTypeDdl}
                        onChange={(e) => handleCaseTypeChange(e)
                        }
                      />
                      
                    </div>
                  </div>
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      Country<span style={{ color: "red" }}> * </span>:
                    </label>
                    <div className="col-md-9">
                      <Select isDisabled={props.match.path.indexOf("edit") > 0}
                        name="country"
                        value={{
                          value: caseFormData.countryId || 0,
                          label: caseFormData.countryName || "Please Select"
                        }}
                        options={countryDdl}
                        onChange={e => {
                          setCaseFormData({
                            ...caseFormData,
                            countryId: e.value,
                            countryName: e.label
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      Basis :
                    </label>
                    <div className="col-md-9">
                      <Select
                        name="basis"
                        value={{
                          value: caseFormData.basisId || 0,
                          label: caseFormData.basisName || "Please Select"
                        }}
                        options={basisDdl}
                        onChange={e => {
                          setCaseFormData({
                            ...caseFormData,
                            basisId: e.value,
                            basisName: e.label
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      No in Series :
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control  form-control-sm"
                        name="noInSeries"
                        value={caseFormData.noInSeries}
                        onChange={onChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group col-md-12">
                  <div className="form-group row">
                    <label className="col-md-1.1 col-form-label form-control-sm sbold">
                      Keep On Top :
                    </label>
                    <div className="input-group col-md-10">
                      <textarea
                        className="form-control form-control-sm"
                        rows="3"
                        name="keepOnTop"
                        value={caseFormData.keepOnTop}
                        onChange={onChange}
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-2">
              <div className="form-group col">
                <div className="card mb-3">
                  <div className="card-header text-white bg-primary">
                    Other Details
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 labelPadRight">
                        <div className="form-group row col">
                          <label className="col-md-3 col-form-label form-control-sm sbold">
                            Purchase Order No :
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control  form-control-sm"
                              name="purchaseOrderNo"
                              value={caseFormData.purchaseOrderNo}
                              onChange={onChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 labelPadRight">
                        <div className="form-group row col">
                          <label className="col-md-3 col-form-label form-control-sm sbold">
                            Tax Treatment :
                          </label>
                          <div className="col-md-9">
                            <Select
                              name="taxTreatment"
                              value={{
                                value: caseFormData.taxTreatmentId || 0,
                                label:
                                  caseFormData.taxTreatmentName ||
                                  "Please Select"
                              }}
                              options={taxTreatmentDdl}
                              onChange={e => {
                                setCaseFormData({
                                  ...caseFormData,
                                  taxTreatmentId: e.value,
                                  taxTreatmentName: e.label
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 labelPadRight">
                        <div className="form-group row col">
                          <label className="col-md-3 col-form-label form-control-sm sbold">
                            Case Status :
                          </label>
                          <div className="col-md-9">
                            <Select
                              name="caseStatus"
                              value={{
                                value: caseFormData.caseStatusId || 0,
                                label:
                                  caseFormData.caseStatusName || "Please Select"
                              }}
                              options={caseStatusDdl}
                              onChange={e => {
                                setCaseFormData({
                                  ...caseFormData,
                                  caseStatusId: e.value,
                                  caseStatusName: e.label
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 labelPadRight">
                        <div className="form-group row col">
                          <label className="col-md-3 col-form-label form-control-sm sbold">
                            Billing Currency :
                          </label>
                          <div className="col-md-9">
                            <Select
                              name="billingCurrency"
                              value={{
                                value: caseFormData.billingCurrencyId || 0,
                                label:
                                  caseFormData.billingCurrencyCode ||
                                  "Please Select"
                              }}
                              options={billingCurrencyDdl}
                              onChange={e => {
                                setCaseFormData({
                                  ...caseFormData,
                                  billingCurrencyId: e.value,
                                  billingCurrencyCode: e.label
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {button()}
      </div>

      {/* Modal Family */}
      <Modal
        show={showFamily}
        onHide={() => {
          setShowFamily(false);
        }}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Family</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card border-secondary">
            <h5 className="card-header text-white bg-primary"><i className="fa fa-search"></i> Search</h5>
            <div className="card-body">
              <div className="row">
                <div className="col-md-2">
                  <label className="title control-label">Case Title : </label>
                </div>
                <div className="col-md-10">
                    <input
                      type="search"
                      className="form-control"
                      value={searchFormData.title}
                      onChange={ e => setSearchFormData({
                        ...searchFormData, title : e.target.value
                      })}
                    />
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <label className="title control-label">Case Family</label>
                  <input
                    type="search"
                    className="form-control"
                    value={searchFormData.family}
                    onChange={ e => setSearchFormData({
                      ...searchFormData, family : e.target.value
                    })}
                  />
                </div>
                <div className="col-md-3">
                  <label className="title control-label">Case Type</label>
                    <Select 
                      value={{
                        value: searchFormData.caseType.value,
                        label: searchFormData.caseType.label
                      }}
                      options={[{ value: 0, label: "Select All" } , ...caseTypeDdl]}
                      onChange={e => { setSearchFormData({
                        ...searchFormData,
                        caseType : { value: e.value, label: e.label }
                      })}}
                    />
                </div>
                <div className="col-md-3">
                  <label className="title control-label">Basis</label>
                    <Select 
                      value={{
                        value: searchFormData.basis.value,
                        label: searchFormData.basis.label
                      }}
                      options={[{ value: 0, label: "Select All" } , ...basisDdl]}
                      onChange={e => { setSearchFormData({
                        ...searchFormData,
                        basis : { value: e.value, label: e.label }
                      })}}
                    />
                </div>
                <div className="col-md-3">
                  <label className="title control-label">Type of Mark</label>
                    <Select 
                      value={{
                        value: searchFormData.typeOfMark.value,
                        label: searchFormData.typeOfMark.label
                      }}
                      options={[{ value: 0, label: "Select All" } , ...typeOfMarkDdl]}
                      onChange={e => { setSearchFormData({
                        ...searchFormData,
                        typeOfMark : { value: e.value, label: e.label }
                      })}}
                    />
                </div>
              </div>
            </div>
          </div>
          <div className="table-responsive">
            <DataTable
              noHeader={true}
              pagination={true}
              columns={familyColumn}
              data={familyData.filter(function(data) {
                return ((searchFormData.typeOfMark.value === 0) || data.typeOfMarkId === searchFormData.typeOfMark.value) && 
                ((searchFormData.caseType.value === 0) || data.caseTypeId === searchFormData.caseType.value) &&
                ((searchFormData.basis.value === 0) || data.basisId === searchFormData.basis.value) &&
                data.title.toLowerCase().includes(searchFormData.title.toLowerCase()) &&
                data.family.toLowerCase().includes(searchFormData.family.toLowerCase())
                  ;
              })}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger ml-2"
            type="button"
            onClick={() => {
              setShowFamily(false);
            }}
          >
            <i className="fa fa-reply"></i> Close
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Family */}

      {/* Modal Save */}
      <Modal
        show={showConfirm}
        onHide={() => {
          setShowConfirm(false);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <button
            className="btn btn-danger ml-2"
            onClick={() => {
              setShowConfirm(false);
            }}
          >
            <i className="fa fa-reply"></i> Cancel
          </button>
          <button
            className="btn btn-success ml-2"
            type="button"
            onClick={checkdup}
          >
            <i className="fa fa-floppy-o"></i> Save
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Save */}

      {/* Modal Case Duplicate */}
      <Modal
        show={showDuplicate}
        onHide={() => {
          setShowDuplicate(false);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alerts />
          <p>Case already exist in the system, create new one?</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger ml-2"
            onClick={() => {
              setShowDuplicate(false);
            }}
          >
            <i className="fa fa-reply"></i> Cancel
          </button>
          <button
            className="btn btn-success ml-2"
            type="button"
            onClick={() => {
              saveAdd();
              //setShowDuplicate(false);
              }
            }
          >
            <i className="fa fa-floppy-o"></i> Save
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Case Duplicate */}
    </Layout>
  );
};

export default CaseEdit;
